export function reorderByPrioritySmart<
    T extends { prioridadeCliente?: number }
>(
    items: T[],
    findItem: (item: T) => boolean,
    toPriority: number
): T[] {
    const prioritized = items
        .filter(item => item.prioridadeCliente != null)
        .sort(
            (a, b) =>
                (a.prioridadeCliente ?? 0) - (b.prioridadeCliente ?? 0)
        );

    const nonPrioritized = items.filter(
        item => item.prioridadeCliente == null
    );

    const item = items.find(findItem);
    if (!item) return items;

    const target = Math.min(
        Math.max(toPriority, 1),
        prioritized.length + 1
    );
   
    const base = prioritized.filter(i => i !== item);
    
    base.splice(target - 1, 0, item);

    const reorderedPrioritized = base.map((i, index) => ({
        ...i,
        prioridadeCliente: index + 1,
    }));

    return [
        ...reorderedPrioritized,
        ...nonPrioritized.filter(i => i !== item),
    ];
}
